<template>
  <div class="agenda-expanded">
    <p class="s-heading ml-2">TOPICS</p>
    <b-row class="ml-1">
      <b-col>
        <p v-html="panelInfo.topics" class="panel-info"></p>
      </b-col>
    </b-row>
    <p class="s-heading ml-2">Moderators</p>
    <b-row class="ml-1">
      <b-col
        class="speaker-img"
        sm="6"
        v-for="{ customer, details } in getSpeakers('moderator')"
        :key="customer"
      >
        <router-link
          :to="{
            name: 'userProfilePage',
            params: { customerId: customer }
          }"
        >
          <b-row>
            <b-col class="speaker-photo-container" sm="4">
              <img class="moderator-photo" :src="details.prof_pic" alt="" />
            </b-col>
            <b-col class="speaker-info-container" sm="8">
              <p class="speaker-username">{{ details.name }}</p>
              <p class="speaker-position">
                {{ details.job_title }}
              </p>
              <router-link
                :to="{
                  name: 'companyProfile',
                  params: { companyId: details.company_id }
                }"
              >
                <p class="speaker-company">{{ details.company }}</p>
              </router-link>
            </b-col>
          </b-row>
        </router-link>
      </b-col>
    </b-row>
    <p class="s-heading ml-2">Keynote Speakers</p>
    <b-row class="ml-1">
      <b-col
        class="speaker-img"
        sm="6"
        v-for="{ customer, details } in getSpeakers('keynote_speaker')"
        :key="customer"
      >
        <router-link
          :to="{
            name: 'userProfilePage',
            params: { customerId: customer }
          }"
        >
          <b-row>
            <b-col class="speaker-photo-container" sm="4">
              <img class="moderator-photo" :src="details.prof_pic" alt="" />
            </b-col>
            <b-col class="speaker-info-container" sm="8">
              <p class="speaker-username">{{ details.name }}</p>
              <p class="speaker-position">
                {{ details.job_title }}
              </p>
              <router-link
                :to="{
                  name: 'companyProfile',
                  params: { companyId: details.company_id }
                }"
              >
                <p class="speaker-company">{{ details.company }}</p>
              </router-link>
            </b-col>
          </b-row>
        </router-link>
      </b-col>
    </b-row>
    <p class="s-heading ml-2">Panelists</p>
    <b-row class="ml-1">
      <b-col
        class="speaker-img"
        sm="6"
        v-for="{ customer, details } in getSpeakers('panelist')"
        :key="customer"
      >
        <router-link
          :to="{
            name: 'userProfilePage',
            params: { customerId: customer }
          }"
        >
          <b-row>
            <b-col class="speaker-photo-container" sm="4">
              <img class="moderator-photo" :src="details.prof_pic" alt="" />
            </b-col>
            <b-col class="speaker-info-container" sm="8">
              <p class="speaker-username">{{ details.name }}</p>
              <p class="speaker-position">
                {{ details.job_title }}
              </p>
              <router-link
                :to="{
                  name: 'companyProfile',
                  params: { companyId: details.company_id }
                }"
              >
                <p class="speaker-company">{{ details.company }}</p>
              </router-link>
            </b-col>
          </b-row>
        </router-link>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'AgendaPanelInfo',
  data() {
    return {};
  },
  props: {
    panelInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    getSpeakers(type) {
      return this.panelInfo.members.filter(member => member.type === type);
    },
  },
};
</script>

<style scoped>
.moderator-photo {
  width: 50px;
  height: 55px;
  margin-top: 3px;
  object-fit: cover;
}
.panel-info{
  font-size: 13px;
}
p {
  margin: 0;
}
.speaker-photo-container {
  padding: 0;
  max-width: 50px;
}
.speaker-img {
  border: 1px solid #dfdfdfeb;
  max-width: 300px;
  margin: 5px 5px;
  height: 62px;
  cursor: pointer;
  background-color: white;
}
.speaker-info-container {
    display: flex;
    flex-direction: column;
    align-content: flex-start;
    justify-content: center;
    align-items: flex-start;
}
.speaker-info-container > p {
  line-height: 11px;
  font-size: 12px;
  padding-top: 0px;
  width: 200px;
  color: rgb(29, 29, 29);
}
.speaker-username {
  font-weight: bold;
  text-transform: capitalize;
  margin-top: 3px;
}
.speaker-position {
  text-transform: capitalize;
  color: #333333;
  font-size: 11px !important;
}
.speaker-company {
  color: #bd9d5f!important;
  text-transform: capitalize;
  font-size: 10px !important;
}
.s-heading {
  margin-top: 20px;
  color: #bd9d5f;
  text-transform: uppercase;
  font-size: 14px;
}
.agenda-expanded {
  padding: 10px;
  background-color: #f3f3f3;
  margin-left: 59px;
  width: calc(100% - 59px);
}
</style>
